import { render, staticRenderFns } from "./itemcaracteristicas.vue?vue&type=template&id=0431cb8b"
import script from "./itemcaracteristicas.vue?vue&type=script&lang=js"
export * from "./itemcaracteristicas.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports